import AdminIconOriginal from "../assets/admin.svg?react";
import AirplayIconOriginal from "../assets/air_play_icon.svg?react";
import AlertTriangleIconOriginal from "../assets/alert_triangle_icon.svg?react";
import ArrowDownFillIconOriginal from "../assets/arrow-down-fill.svg?react";
import ArrowLineRightIconOriginal from "../assets/arrow-line-right.svg?react";
import RefreshIconOriginal from "../assets/arrow_clockwise.svg?react";
import ArrowDownIconOriginal from "../assets/arrow_down.svg?react";
import ArrowRightIconOriginal from "../assets/arrow_right_icon.svg?react";
import ArrowUpIconOriginal from "../assets/arrow_up.svg?react";
import ArrowsClockwiseIconOriginal from "../assets/arrows_clockwise.svg?react";
import ArrowsInIconOriginal from "../assets/arrows_in_icon.svg?react";
import ArrowsOutIconOriginal from "../assets/arrows_out_icon.svg?react";
import NotificationsIconOriginal from "../assets/bell.svg?react";
import BellSimpleIconOriginal from "../assets/bell_simple_icon.svg?react";
import BracketsCurlyIconOriginal from "../assets/brackets_curly_icon.svg?react";
import CalendarIconOriginal from "../assets/calendar_icon.svg?react";
import CardsIconOriginal from "../assets/cards_icon.svg?react";
import CaretRightIconOriginal from "../assets/caret_right_icon.svg?react";
import ChartBarIconOriginal from "../assets/chart_bar_icon.svg?react";
import ChartLineIconOriginal from "../assets/chart_line_icon.svg?react";
import ChartLineUpIconOriginal from "../assets/chart_line_up_icon.svg?react";
import ChatTextIconOriginal from "../assets/chat_text_icon.svg?react";
import CheckBoldIconOriginal from "../assets/check_bold_icon.svg?react";
import CheckCircleFillIconOriginal from "../assets/check_circle_fill_icon.svg?react";
import CheckCircleIconOriginal from "../assets/check_circle_icon.svg?react";
import CheckIconOriginal from "../assets/check_icon.svg?react";
import CheckboxIconOriginal from "../assets/checkbox.svg?react";
import ChevronDownIconOriginal from "../assets/chevron-down.svg?react";
import CircleIconOriginal from "../assets/circle_icon.svg?react";
import CirclesThreeIconOriginal from "../assets/circles-three.svg?react";
import ClearIconOriginal from "../assets/clear_icon.svg?react";
import ClockCounterClockwiseIconOriginal from "../assets/clock_counter_clockwise_icon.svg?react";
import ClockIconOriginal from "../assets/clock_icon.svg?react";
import CloudOperationsIconOriginal from "../assets/cloud-operations.svg?react";
import CloudArrowUpIconOriginal from "../assets/cloud_arrow_up_icon.svg?react";
import CloudIconOriginal from "../assets/cloud_icon.svg?react";
import CodeBlockIconOriginal from "../assets/code_block_icon.svg?react";
import CodeIconOriginal from "../assets/code_icon.svg?react";
import ColumnsIconOriginal from "../assets/columns_icon.svg?react";
import CompassToolIconOriginal from "../assets/compass_tool_icon.svg?react";
import CopyIconOriginal from "../assets/copy_v2.svg?react";
import CubeIconOriginal from "../assets/cube.svg?react";
import CurrencyDollarIconOriginal from "../assets/currency_dollar_icon.svg?react";
import DashIconOriginal from "../assets/dash_icon.svg?react";
import DatabaseIconOriginal from "../assets/database_icon.svg?react";
import DensityComfortableIconOriginal from "../assets/density_comfortable_icon.svg?react";
import DensityCompactIconOriginal from "../assets/density_compact_icon.svg?react";
import DensityStandardIconOriginal from "../assets/density_standard_icon.svg?react";
import DiffIconOriginal from "../assets/diff_icon.svg?react";
import DotsThreeVerticalIconBoldOriginal from "../assets/dots_three_vertical_icon_bold.svg?react";
import DoubleChevronLeftBoldIconOriginal from "../assets/double_chevron_left_bold_icon.svg?react";
import DoubleChevronRightBoldIconOriginal from "../assets/double_chevron_right_bold_icon.svg?react";
import DownloadSimpleIconOriginal from "../assets/download_simple_icon.svg?react";
import EditIconOriginal from "../assets/edit.svg?react";
import ExportBoldIconOriginal from "../assets/export_bold_icon.svg?react";
import ExportIconOriginal from "../assets/export_icon.svg?react";
import ExternalLinkIconOriginal from "../assets/external_link_icon.svg?react";
import EyeIconOriginal from "../assets/eye_icon.svg?react";
import EyeSlashedIconOriginal from "../assets/eye_slashed_icon.svg?react";
import DefaultLogoOriginal from "../assets/fi_layers.svg?react";
import StackFilledIconOriginal from "../assets/fi_layers_filled_icon.svg?react";
import FileSearchIconOriginal from "../assets/file-search.svg?react";
import FileCssIconOriginal from "../assets/file_css_icon.svg?react";
import FileIconOriginal from "../assets/file_icon.svg?react";
import FileTextFillIconOriginal from "../assets/file_text_fill_icon.svg?react";
import FileTextIconOriginal from "../assets/file_text_icon.svg?react";
import FilesIconOriginal from "../assets/files.svg?react";
import Files2IconOriginal from "../assets/files_icon.svg?react";
import FolderIconOriginal from "../assets/folder_icon.svg?react";
import FoldersIconOriginal from "../assets/folders.svg?react";
import FilterIconOriginal from "../assets/funnel.svg?react";
import FunnelBoldIconOriginal from "../assets/funnel_bold_icon.svg?react";
import GearIconOriginal from "../assets/gear_icon.svg?react";
import GitLogoOriginal from "../assets/git_logo.svg?react";
import GraphIconOriginal from "../assets/graph_icon.svg?react";
import GridNineIconOriginal from "../assets/grid_nine_icon.svg?react";
import GroupIconOriginal from "../assets/group.svg?react";
import UserGroupIconOriginal from "../assets/group_icon.svg?react";
import HomeIconOriginal from "../assets/home.svg?react";
import HouseLineIconOriginal from "../assets/house-line.svg?react";
import InfoCheckFillIconOriginal from "../assets/info_check_fill_icon.svg?react";
import InfoIconOriginal from "../assets/info_icon.svg?react";
import InfoIconBoldOriginal from "../assets/info_icon_bold.svg?react";
import InsecureIconOriginal from "../assets/insecure_icon.svg?react";
import JiraBugIconOriginal from "../assets/jira_bug_icon.svg?react";
import JiraCheckSquareIconOriginal from "../assets/jira_check_square_icon.svg?react";
import JiraLogoIconOriginal from "../assets/jira_logo_icon.svg?react";
import KeyIconOriginal from "../assets/key_icon.svg?react";
import KeyboardIconOriginal from "../assets/keyboard_icon.svg?react";
import KeyholeIconOriginal from "../assets/keyhole_icon.svg?react";
import LightbulbFillIconOriginal from "../assets/lightbulb_fill_icon.svg?react";
import ListDashesIconOriginal from "../assets/list_dashes_icon.svg?react";
import ListMagnifyingGlassIconOriginal from "../assets/list_magnifying_glass_icon.svg?react";
import LockIconOriginal from "../assets/lock_icon.svg?react";
import MinusCircleIconOriginal from "../assets/minus_circle_icon.svg?react";
import MinusIconOriginal from "../assets/minus_icon.svg?react";
import NegativeSolidIconOriginal from "../assets/negative-solid.svg?react";
import NotePencilIconOriginal from "../assets/note_pencil_icon.svg?react";
import NotificationIconOriginal from "../assets/notification_icon.svg?react";
import OpsCostIconOriginal from "../assets/ops_cost.svg?react";
import PaletteIconOriginal from "../assets/palette_icon.svg?react";
import PaperPlaneTiltIconOriginal from "../assets/paper_plane_tilt_icon.svg?react";
import PencilIconOriginal from "../assets/pencil_icon.svg?react";
import PencilSimpleIconOriginal from "../assets/pencil_simple_icon.svg?react";
import DynamicCollectionIconOriginal from "../assets/perspective.svg?react";
import PerspectiveIconOriginal from "../assets/perspective_icon.svg?react";
import PlugsConnectedIconOriginal from "../assets/plugs_connected_icon.svg?react";
import PlusIconOriginal from "../assets/plus.svg?react";
import PlusCircleIconOriginal from "../assets/plus_circle_icon.svg?react";
import PresentationChartIconOriginal from "../assets/presentation_chart_icon.svg?react";
import AwsWhiteLogoOriginal from "../assets/providers/aws-white.svg?react";
import AwsLogoOriginal from "../assets/providers/aws.svg?react";
import AzureLogoOriginal from "../assets/providers/azure.svg?react";
import GcpLogoOriginal from "../assets/providers/gcp.svg?react";
import TencentCloudLogoOriginal from "../assets/providers/tencentcloud.svg?react";
import QueryIconOriginal from "../assets/query.svg?react";
import QuestionIconOriginal from "../assets/question_icon.svg?react";
import RepeatIconOriginal from "../assets/repeat_icon.svg?react";
import RocketLaunchIconOriginal from "../assets/rocket_launch_icon.svg?react";
import RowsIconOriginal from "../assets/rows_icon.svg?react";
import ScanIconOriginal from "../assets/scan_icon.svg?react";
import ScrollIconOriginal from "../assets/scroll_icon.svg?react";
import SearchIconOriginal from "../assets/search_icon.svg?react";
import SecureIconOriginal from "../assets/secure_icon.svg?react";
import SettingsIconOriginal from "../assets/settings.svg?react";
import SidebarSimpleIconOriginal from "../assets/sidebar_simple_icon.svg?react";
import SparkleIconOriginal from "../assets/sparkle_icon.svg?react";
import SpinnerGapIconOriginal from "../assets/spinner_gap_icon.svg?react";
import StackletLogoOriginal from "../assets/stacklet_logo.svg?react";
import StarIconOriginal from "../assets/star_icon.svg?react";
import TagChevronIconOriginal from "../assets/tag_chevron_icon.svg?react";
import TagIconOriginal from "../assets/tag_icon.svg?react";
import TileViewIconOriginal from "../assets/tile_view.svg?react";
import ToolsIconOriginal from "../assets/tools.svg?react";
import TrashIconOriginal from "../assets/trash_icon.svg?react";
import UpdateIconOriginal from "../assets/update_icon.svg?react";
import UserCheckIconOriginal from "../assets/user_check_icon.svg?react";
import UserCircleGearIconOriginal from "../assets/user_circle_gear_icon.svg?react";
import UserCircleIconOriginal from "../assets/user_circle_icon.svg?react";
import UserIconOriginal from "../assets/user_icon.svg?react";
import UserMinusIconOriginal from "../assets/user_minus_icon.svg?react";
import UserPlusIconOriginal from "../assets/user_plus_icon.svg?react";
import UserXIconOriginal from "../assets/user_x_icon.svg?react";
import WarningCircleFillIconOriginal from "../assets/warning_circle_fill_icon.svg?react";
import WarningCircleIconOriginal from "../assets/warning_circle_icon.svg?react";
import WebhookIconOriginal from "../assets/webhook_icon.svg?react";
import XCircleFillIconOriginal from "../assets/x_circle_fill_icon.svg?react";
import XIconOriginal from "../assets/x_icon.svg?react";
// Original SVGR imports
import { withSize } from "./withSize";

export const AdminIcon = withSize(AdminIconOriginal);
export const AirplayIcon = withSize(AirplayIconOriginal);
export const AlertTriangleIcon = withSize(AlertTriangleIconOriginal);
export const ArrowDownFillIcon = withSize(ArrowDownFillIconOriginal);
export const ArrowDownIcon = withSize(ArrowDownIconOriginal);
export const ArrowUpIcon = withSize(ArrowUpIconOriginal);
export const ArrowLineRightIcon = withSize(ArrowLineRightIconOriginal);
export const ArrowsInIcon = withSize(ArrowsInIconOriginal);
export const ArrowsOutIcon = withSize(ArrowsOutIconOriginal);
export const ArrowsClockwiseIcon = withSize(ArrowsClockwiseIconOriginal);
export const ArrowRightIcon = withSize(ArrowRightIconOriginal);
export const BellSimpleIcon = withSize(BellSimpleIconOriginal);
export const BracketsCurlyIcon = withSize(BracketsCurlyIconOriginal);
export const CalendarIcon = withSize(CalendarIconOriginal);
export const CardsIcon = withSize(CardsIconOriginal);
export const CaretRightIcon = withSize(CaretRightIconOriginal);
export const ChartBarIcon = withSize(ChartBarIconOriginal);
export const ChartLineIcon = withSize(ChartLineIconOriginal);
export const ChartLineUpIcon = withSize(ChartLineUpIconOriginal);
export const ChatTextIcon = withSize(ChatTextIconOriginal);
export const CheckIcon = withSize(CheckIconOriginal);
export const CheckCircleIcon = withSize(CheckCircleIconOriginal);
export const CheckCircleFillIcon = withSize(CheckCircleFillIconOriginal);
export const CheckBoldIcon = withSize(CheckBoldIconOriginal);
export const CheckboxIcon = withSize(CheckboxIconOriginal);
export const ChevronDownIcon = withSize(ChevronDownIconOriginal);
export const CirclesThreeIcon = withSize(CirclesThreeIconOriginal);
export const CircleIcon = withSize(CircleIconOriginal);
export const ClearIcon = withSize(ClearIconOriginal);
export const ClockCounterClockwiseIcon = withSize(ClockCounterClockwiseIconOriginal);
export const ClockIcon = withSize(ClockIconOriginal);
export const CloudArrowUpIcon = withSize(CloudArrowUpIconOriginal);
export const CloudIcon = withSize(CloudIconOriginal);
export const CloudOperationsIcon = withSize(CloudOperationsIconOriginal);
export const CodeIcon = withSize(CodeIconOriginal);
export const CodeBlockIcon = withSize(CodeBlockIconOriginal);
export const ColumnsIcon = withSize(ColumnsIconOriginal);
export const CompassToolIcon = withSize(CompassToolIconOriginal);
export const CopyIcon = withSize(CopyIconOriginal);
export const CubeIcon = withSize(CubeIconOriginal);
export const CurrencyDollarIcon = withSize(CurrencyDollarIconOriginal);
export const DashIcon = withSize(DashIconOriginal);
export const DatabaseIcon = withSize(DatabaseIconOriginal);
export const DensityComfortableIcon = withSize(DensityComfortableIconOriginal);
export const DensityCompactIcon = withSize(DensityCompactIconOriginal);
export const DensityStandardIcon = withSize(DensityStandardIconOriginal);
export const DotsThreeVerticalIconBold = withSize(DotsThreeVerticalIconBoldOriginal);
export const DiffIcon = withSize(DiffIconOriginal);
export const DoubleChevronLeftBoldIcon = withSize(DoubleChevronLeftBoldIconOriginal);
export const DoubleChevronRightBoldIcon = withSize(DoubleChevronRightBoldIconOriginal);
export const DownloadSimpleIcon = withSize(DownloadSimpleIconOriginal);
export const DynamicCollectionIcon = withSize(DynamicCollectionIconOriginal);
export const EditIcon = withSize(EditIconOriginal);
export const ExportBoldIcon = withSize(ExportBoldIconOriginal);
export const ExportIcon = withSize(ExportIconOriginal);
export const ExternalLinkIcon = withSize(ExternalLinkIconOriginal);
export const EyeIcon = withSize(EyeIconOriginal);
export const EyeSlashedIcon = withSize(EyeSlashedIconOriginal);
export const FileCssIcon = withSize(FileCssIconOriginal);
export const FileIcon = withSize(FileIconOriginal);
export const FileTextIcon = withSize(FileTextIconOriginal);
export const FileTextFillIcon = withSize(FileTextFillIconOriginal);
export const Files2Icon = withSize(Files2IconOriginal);
export const FileSearchIcon = withSize(FileSearchIconOriginal);
export const FilesIcon = withSize(FilesIconOriginal);
export const FilterIcon = withSize(FilterIconOriginal);
export const FoldersIcon = withSize(FoldersIconOriginal);
export const FolderIcon = withSize(FolderIconOriginal);
export const FunnelBoldIcon = withSize(FunnelBoldIconOriginal);
export const GearIcon = withSize(GearIconOriginal);
export const GraphIcon = withSize(GraphIconOriginal);
export const GridNineIcon = withSize(GridNineIconOriginal);
export const GroupIcon = withSize(GroupIconOriginal);
export const HomeIcon = withSize(HomeIconOriginal);
export const HouseLineIcon = withSize(HouseLineIconOriginal);
export const InfoIcon = withSize(InfoIconOriginal);
export const InfoIconBold = withSize(InfoIconBoldOriginal);
export const InfoCheckFillIcon = withSize(InfoCheckFillIconOriginal);
export const InsecureIcon = withSize(InsecureIconOriginal);
export const JiraBugIcon = withSize(JiraBugIconOriginal);
export const JiraCheckSquareIcon = withSize(JiraCheckSquareIconOriginal);
export const JiraLogoIcon = withSize(JiraLogoIconOriginal);
export const KeyboardIcon = withSize(KeyboardIconOriginal);
export const KeyholeIcon = withSize(KeyholeIconOriginal);
export const KeyIcon = withSize(KeyIconOriginal);
export const LightbulbFillIcon = withSize(LightbulbFillIconOriginal);
export const ListDashesIcon = withSize(ListDashesIconOriginal);
export const ListMagnifyingGlassIcon = withSize(ListMagnifyingGlassIconOriginal);
export const LockIcon = withSize(LockIconOriginal);
export const MinusIcon = withSize(MinusIconOriginal);
export const MinusCircleIcon = withSize(MinusCircleIconOriginal);
export const NegativeSolidIcon = withSize(NegativeSolidIconOriginal);
export const NotePencilIcon = withSize(NotePencilIconOriginal);
export const NotificationIcon = withSize(NotificationIconOriginal);
export const NotificationsIcon = withSize(NotificationsIconOriginal);
export const OpsCostIcon = withSize(OpsCostIconOriginal);
export const PaletteIcon = withSize(PaletteIconOriginal);
export const PaperPlaneTiltIcon = withSize(PaperPlaneTiltIconOriginal);
export const PencilIcon = withSize(PencilIconOriginal);
export const PencilSimpleIcon = withSize(PencilSimpleIconOriginal);
export const PerspectiveIcon = withSize(PerspectiveIconOriginal);
export const PlugsConnectedIcon = withSize(PlugsConnectedIconOriginal);
export const PlusCircleIcon = withSize(PlusCircleIconOriginal);
export const PlusIcon = withSize(PlusIconOriginal);
export const PresentationChartIcon = withSize(PresentationChartIconOriginal);
export const QueryIcon = withSize(QueryIconOriginal);
export const QuestionIcon = withSize(QuestionIconOriginal);
export const RefreshIcon = withSize(RefreshIconOriginal);
export const RepeatIcon = withSize(RepeatIconOriginal);
export const RocketLaunchIcon = withSize(RocketLaunchIconOriginal);
export const RowsIcon = withSize(RowsIconOriginal);
export const ScanIcon = withSize(ScanIconOriginal);
export const ScrollIcon = withSize(ScrollIconOriginal);
export const SearchIcon = withSize(SearchIconOriginal);
export const SecureIcon = withSize(SecureIconOriginal);
export const SettingsIcon = withSize(SettingsIconOriginal);
export const SidebarSimpleIcon = withSize(SidebarSimpleIconOriginal);
export const SparkleIcon = withSize(SparkleIconOriginal);
export const SpinnerGapIcon = withSize(SpinnerGapIconOriginal);
export const StackFilledIcon = withSize(StackFilledIconOriginal);
export const StarIcon = withSize(StarIconOriginal);
export const WarningCircleFillIcon = withSize(WarningCircleFillIconOriginal);
export const WarningCircleIcon = withSize(WarningCircleIconOriginal);
export const TagChevronIcon = withSize(TagChevronIconOriginal);
export const TagIcon = withSize(TagIconOriginal);
export const TileViewIcon = withSize(TileViewIconOriginal);
export const ToolsIcon = withSize(ToolsIconOriginal);
export const TrashIcon = withSize(TrashIconOriginal);
export const UpdateIcon = withSize(UpdateIconOriginal);
export const UserCheckIcon = withSize(UserCheckIconOriginal);
export const UserGroupIcon = withSize(UserGroupIconOriginal);
export const UserCircleIcon = withSize(UserCircleIconOriginal);
export const UserCircleGearIcon = withSize(UserCircleGearIconOriginal);
export const UserIcon = withSize(UserIconOriginal);
export const UserMinusIcon = withSize(UserMinusIconOriginal);
export const UserPlusIcon = withSize(UserPlusIconOriginal);
export const UserXIcon = withSize(UserXIconOriginal);
export const WebhookIcon = withSize(WebhookIconOriginal);
export const XCircleFillIcon = withSize(XCircleFillIconOriginal);
export const XIcon = withSize(XIconOriginal);

// Logos
export const AwsLogo = withSize(AwsLogoOriginal);
export const AwsWhiteLogo = withSize(AwsWhiteLogoOriginal);
export const AzureLogo = withSize(AzureLogoOriginal);
export const DefaultLogo = withSize(DefaultLogoOriginal);
export const GcpLogo = withSize(GcpLogoOriginal);
export const GitLogo = withSize(GitLogoOriginal);
export const StackletLogo = withSize(StackletLogoOriginal);
export const TencentCloudLogo = withSize(TencentCloudLogoOriginal);

// SystemIcon and utilities
export { SystemIcon } from "./SystemIcon";
export { withSize, type IconWithSizeProps } from "./withSize";
